import { useEffect } from 'react';
import { useLocation, Location } from 'react-router-dom';

export function useRouteChange(callback: (location: Location) => void) {
  const location = useLocation();

  useEffect(() => {
    callback(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
